'use strict';

export let CategoriasRouteComponent = {

    selector: 'categoriasRoute',
    template: require('./categorias-route.component.html'),
    bindings: {
        categorias: '='
    },
    controller: class {
        categoriaSeleccionada = null;
        subcategoriaSeleccionada = null;


        nuevaCategoria;
        nuevaSubcategoria;

        /*@ngInject*/
        constructor(ToasterService, CategoriasService, $location) {
            Object.assign(this, {ToasterService, CategoriasService, $location});
            this.guardandoDatos = false;
        }

        agregarNuevaCategoria() {
            if (this.nuevaCategoria) {
                this.categorias.push({
                    categoria: this.nuevaCategoria.toUpperCase(),
                    subcategorias: [],
                    nuevoItem: true
                });
                this.ToasterService.popUp('success', 'Categoria', 'Se ha agregado la categoria. Recuerda guardar los cambios');
                this.nuevaCategoria = '';
            } else {
                this.ToasterService.popUp('info', 'Categoria', 'Escriba el nombre de la nueva categoria.');
            }
        }

        agregarNuevaSubcategoria() {
            if (this.nuevaSubcategoria) {
                this.categoriaSeleccionada.subcategorias.push({subcategoria: this.nuevaSubcategoria, nuevoItem: true});
                this.ToasterService.popUp('success', 'Subcategoria', 'Se ha agregado la subcategoria. Recuerda guardar los cambios');
                this.nuevaSubcategoria = '';
            } else {
                this.ToasterService.popUp('info', 'Subcategoria', 'Escriba el nombre de la nueva subcategoria.');
            }
        }

        eliminarCategoria() {
            let index = this.categorias.indexOf(this.categoriaSeleccionada);
            if (index !== -1) {
                this.categorias.splice(index, 1);
                this.ToasterService.popUp('success', 'Categoria', 'Se ha eliminado la categoria. Recuerda guardar los cambios');
            } else {
                this.ToasterService.popUp('info', 'Categoria', 'La categoria no se ha encontrado.');
            }
        }

        eliminarSubCategoria() {
            let index = this.categoriaSeleccionada.subcategorias.indexOf(this.subcategoriaSeleccionada);
            if (index !== -1) {
                this.categoriaSeleccionada.subcategorias.splice(index, 1);
                this.ToasterService.popUp('success', 'Subcategoria', 'Se ha eliminado la subcategoria. Recuerda guardar los cambios');
            } else {
                this.ToasterService.popUp('info', 'Categoria', 'La subcategoria no se ha encontrado.');
            }
        }

        guardarCambiosCategorias() {
            this.guardandoDatos = true;
            this.CategoriasService.guardarCambiosCategorias({categorias: this.categorias})
                .then(res => {
                    this.categorias = res.data;
                    this.ToasterService.popUp('success', 'Categorias', 'Los cambios se han guardado.');
                    this.$location.path('/');
                })
                .catch(err => {
                    this.guardandoDatos = false;
                    this.ToasterService.popUp('error', 'Error', 'Se ha producido un error.');
                })
        }
    }
};


// WEBPACK FOOTER //
// ./client/app/categorias-route/categorias-route.component.js